import { useMemo, useState } from 'react'
import {
  deleteCompanyGroup,
  getCompaniesGroupsWithItems,
} from '../../../../services/api/https/system/system.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  DELETE_SUCCESS: 'Grupo de Empresas deletado com sucesso',
  DELETE_COMPANY_GROUP: 'Deletando Grupo de Empresas',
  GET_COMPANIES_GROUPS: 'Adquirindo Grupos de Empresas',
}

const INITIAL_STATE = {
  companiesGroup: [],
  modalEdit: { show: false, data: null },
  modalAssoc: { show: false, data: null },
  globalFilter: '',
  selectedCompanyGroup: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useCompaniesGroup() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getCompaniesGroupWithItems() {
        getCompaniesGroupsWithItems()
          .then(response => {
            setState(prevState => ({
              ...prevState,
              companiesGroup: response,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      deleteCompanyGroup(companyGroupId) {
        deleteCompanyGroup(companyGroupId)
          .then(() =>
            setState(prevState => {
              prevState.companiesGroup = prevState.companiesGroup.filter(
                cg => cg.id !== companyGroupId,
              )
              prevState.loadingMessage = LOAD_MESSAGE.DELETE_SUCCESS
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onMenuItemClicked(item, data) {
        switch (item) {
          case 'Apagar':
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.DELETE_COMPANY_GROUP,
              selectedCompanyGroup: data,
            }))
            break
          case 'Editar':
            setState(prevState => ({ ...prevState, modalEdit: { show: true, data: data } }))
            break
          case 'Assoc. Empresas':
            setState(prevState => ({ ...prevState, modalAssoc: { show: true, data: data } }))
            break
          default:
            break
        }
      },

      onBtnNovo() {
        setState(prevState => ({ ...prevState, modalEdit: { show: true, data: null } }))
      },

      onModalSave(modal, payload) {
        if (modal === 'edit') {
          setState(prevState => {
            const index = prevState.companiesGroup.findIndex(c => c.id === payload.id)
            if (index !== -1) prevState.companiesGroup[index] = payload
            else prevState.companiesGroup.push(payload)
            prevState.modalEdit = { show: false, data: null }
            return { ...prevState }
          })
        } else {
          setState(prevState => {
            const index = prevState.companiesGroup.findIndex(c => c.id === payload.id)
            prevState.companiesGroup[index] = payload
            prevState.modalEdit = { show: false, data: null }
            return { ...prevState }
          })
        }
      },

      onModalClose(modal) {
        if (modal === 'edit')
          setState(prevState => ({ ...prevState, modalEdit: { show: false, data: null } }))
        else setState(prevState => ({ ...prevState, modalAssoc: { show: false, data: null } }))
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_COMPANIES_GROUPS }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
